<article 
  id="canvasComponent" 
  class="d-flex flex-nowrap viewerAsset viewerAssetCanvas" 
  [class.justify-content-around]="zoomLevel <= 100" 
  [class.justify-content-between]="zoomLevel > 100" 
  [class.w-100]="zoomLevel > 100">
  <div 
    class="viewerCanvasWrapper mx-auto" 
    [ngClass]="getWrapperClasses()"
    [attr.aria-hidden]="shouldAnnounce() ? null : 'true'"
    [attr.role]="shouldAnnounce() ? 'img' : null"
    [attr.aria-label]="shouldAnnounce() ? (asset?.alternateText || '') : null"
    [tabindex]="shouldAnnounce() ? 0 : -1">
    <zbp-drawing
      *ngIf="background"
      id="canvasDocument"
      [tool]="selectedTool"
      [background]="background"
      [orientation]="getOrientation()"
      [zoomLevel]="zoomLevel"></zbp-drawing>
  </div>
</article>